import { productlistConfig } from '../../../../config';
import { http } from '../../../axios';
import { Pagination } from '../../../../../models/Pagination';
import { MarketplaceProductsResponse } from '../../../../store/apiLibx';
import { AgeCategory } from '../../../../../models/AgeCategory';

export interface LocalRegionProductParams {
    pagination: Pagination;
    filterMap: string;
    region?: string;
    ageCategory?: string | null;
}
export const fetchLocalRegionsProducts = ({ pagination, filterMap, region, ageCategory }: LocalRegionProductParams) => {
    const { page, pageSize, sortBy } = pagination;
    return http
        .post<MarketplaceProductsResponse>(productlistConfig().endpointLibxLocalRegions, filterMap, {
            params: {
                page,
                pageSize,
                sortBy,
                ageCategory: ageCategory === AgeCategory.ALL_AGES ? null : ageCategory
            },
            pathParams: {
                kind: 'products',
                region
            }
        })
        .then(response => response.data);
};
